import {Chart} from "react-google-charts";
import {Button, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from '../../config/config';
import {Helpers} from '../../utils/helpers';
import {PopupMessage} from "../../utils/message";
import {DateTimePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

const options = {
    title: "Lucky Wheel Config Chart",
    pieHole: 0.4,
    is3D: true,
    backgroundColor: "transparent",
    titleTextStyle: {
        color: "white",  // Title text color
    },
    legend: {
        textStyle: {
            color: "white",  // Legend text color
        },
    },
    pieSliceTextStyle: {
        color: "white",  // Slice label text color
    },
};

const DAYS = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
]

const HQ_LEVELS = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
];

const REWARD_TYPES = [
    {label: 'ALL', value: 'ALL'},
    {label: 'MISSED', value: 'Missed'},
    {label: 'GOLD', value: 'Honey'},
    {label: 'OIL', value: 'Flowers'},
    {label: 'SAPPHIRE', value: 'Rubies'},
    {label: 'RUBY', value: 'MarketRuby'},
    {label: 'TICKET', value: 'LuckyWheelTicket'},
]

class LuckyWheelWrapped extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            luckyWheelConfig: {},
            configFilter: {
                day: 1,
                hqLevel: 2,
                show: false,
            },
            filter: {
                userId: '',
                hqLevel: 0,
                loginCount: 0,
                rewardType: 'ALL',
                startDate: new Date(),
                endDate: new Date(),
                offset: 0,
                limit: 50,
            },
            logs: [],
            total: 0,
            userInfo: undefined,
        };
    }

    componentDidMount() {
        this.fetchData();
        this.fetchLogs();
    }

    fetchConfig = async () => {
        const url = `${Config.getInstance.apiUrl}/api/lucky_wheel/config`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {headers});
        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;
            const luckyWheelConfig = data.luckyWheelConfig;

            this.setState({luckyWheelConfig});
        } else {
            PopupMessage.error(`Error: ${response.data.message}`)
        }
    }

    fetchLogs = async () => {
        const url = `${Config.getInstance.apiUrl}/api/lucky_wheel/logs`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({
            loading: true,
        });

        const filter = this.state.filter;

        const response = await axios.get(url, {headers, params: filter});
        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;

            const logs = data.logs;
            const total = data.total;
            const userInfo = data.userInfo;

            console.log(`logs: ${JSON.stringify(logs)}`);
            console.log(`total: ${total}`);
            console.log(`userInfo: ${JSON.stringify(userInfo)}`);

            this.setState({logs, total, userInfo});
        } else {
            PopupMessage.error(`Error: ${response.data.message}`)
        }
    }

    fetchData = async () => {
        await this.fetchConfig();
    }

    onChangeConfigFilter = (key: string, value: any) => {
        const {configFilter} = this.state;
        configFilter[key] = value;

        this.setState({configFilter}, () => {
            this.fetchData();
        });
    }

    onChangeFilter = (key: string, value: any) => {
        const {filter} = this.state;
        filter[key] = value;

        this.setState({filter}, () => {
            this.fetchData();
        });
    }

    onFilterChangeTime = (key: string, value: any) => {
        const {filter} = this.state;
        filter[key] = value;
        this.setState({filter});
    }

    rewardToChartData = (rewards) => {
        const data = [
            ["Category", "Value"],

        ];

        for (const reward of rewards) {
            const category = `[${reward.type}] x${Helpers.formatNumber(reward.amount)}`;
            const value = reward.weight;
            data.push([category, value]);
        }

        return data;
    }

    getRewardType = (type) => {
        const rewardType = REWARD_TYPES.find((reward) => reward.value === type);
        return rewardType ? rewardType.label : type
    }

    renderCircle = () => {
        const {luckyWheelConfig} = this.state;
        const {configFilter} = this.state;

        const hqLevel = configFilter.hqLevel;
        const show = configFilter.show;

        const hqConfig = luckyWheelConfig.hqConfig || [];

        const wheelConfig = hqConfig.find((config) => config.hqLevel === hqLevel);

        if (!wheelConfig) {
            return null;
        }

        const day = configFilter.day;
        const rewardByDay = wheelConfig.wheelConfig.find((config) => config.daysLogin === day);

        const rewards = rewardByDay.rewards || [];

        const data = this.rewardToChartData(rewards);

        return <Paper>
            <Typography variant="h4">{`Lucky Wheel Config`}</Typography>
            <Button variant="text" color="primary" onClick={(e) => this.onChangeConfigFilter('show', !show)}>
                [{show ? "Hide" : "Show"}]
            </Button>

            <br />
            <br />
            {
                !show ? null :
                    <Grid container spacing={2}>
                        <Grid item container xs={3}>
                            <Grid item container xs={12} spacing={2}>
                                <Grid item xs={5}>
                                    <TextField
                                        label="HQ Level"
                                        select
                                        value={configFilter.hqLevel}
                                        onChange={(e) => this.onChangeConfigFilter('hqLevel', e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            HQ_LEVELS.map((type, index) => {
                                                return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                            })
                                        }
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Day"
                                        select
                                        value={configFilter.day}
                                        onChange={(e) => this.onChangeConfigFilter('day', e.target.value)}
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            DAYS.map((type, index) => {
                                                return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                            })
                                        }
                                    </TextField>
                                </Grid>

                            </Grid>
                            <Grid item xs={12}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Type</TableCell>
                                            <TableCell>Amount</TableCell>
                                            <TableCell>Weight</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            rewards.map((reward, index) => {
                                                return <TableRow key={index}>
                                                    <TableCell>{reward.type}</TableCell>
                                                    <TableCell>{Helpers.formatNumber(reward.amount)}</TableCell>
                                                    <TableCell>{reward.weight}</TableCell>
                                                </TableRow>
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                        <Grid item xs={9}>
                            <Chart
                                chartType="PieChart"
                                data={data}
                                options={options}
                                width={"100%"}
                                height={"400px"}
                            />
                        </Grid>
                    </Grid>
            }
        </Paper>
    }

    renderFilter = () => {
        const {filter} = this.state;
        const {userInfo} = this.state;

        return <Paper>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container xs={12} spacing={2}>
                    <Grid item xs={2}>
                        <TextField
                            label="HQ Level"
                            value={filter.hqLevel}
                            onChange={(e) => this.onChangeFilter('hqLevel', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label="loginCount"
                            value={filter.loginCount}
                            onChange={(e) => this.onChangeFilter('loginCount', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="Start Date"
                                value={filter.startDate}
                                onChange={(value) => this.onFilterChangeTime('startDate', value)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="End Date"
                                value={filter.endDate}
                                onChange={(value) => this.onFilterChangeTime('endDate', value)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
                <Grid item container xs={12} spacing={2}>
                    <Grid item xs={2}>
                        <TextField
                            label="User ID..."
                            value={filter.userId}
                            onChange={(e) => this.onChangeFilter('userId', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label="Reward Type"
                            select
                            value={filter.rewardType}
                            onChange={(e) => this.onChangeFilter('rewardType', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                            {
                                REWARD_TYPES.map((type, index) => {
                                    return <MenuItem key={index} value={type.value}>{type.label}</MenuItem>
                                })
                            }
                        </TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            label="Offset..."
                            value={filter.offset}
                            onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                        </TextField>
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            label="Limit..."
                            value={filter.limit}
                            onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        >
                        </TextField>
                    </Grid>

                </Grid>
                <Grid item container xs={12} spacing={2} justifyContent="space-between">
                    <Grid item xs={10} container justifyContent="flex-start">
                        <Table sx={{border: 1, borderColor: 'grey.400'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>LastLogin</TableCell>
                                    <TableCell>LoginCount</TableCell>
                                    <TableCell>TotalTicket</TableCell>
                                    <TableCell>UsedTicket</TableCell>
                                    <TableCell>TotalSpent</TableCell>
                                    <TableCell>Ticket</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{userInfo ? userInfo.lastLogin : 'Unknown'}</TableCell>
                                    <TableCell>{userInfo ? Helpers.formatNumber(userInfo.loginCount) : 0}</TableCell>
                                    <TableCell>{userInfo ? Helpers.formatNumber(userInfo.totalTicket) : 0}</TableCell>
                                    <TableCell>{userInfo ? Helpers.formatNumber(userInfo.usedTicket) : 0}</TableCell>
                                    <TableCell>{userInfo ? Helpers.formatNumber(userInfo.totalSpent) : 0}</TableCell>
                                    <TableCell>{userInfo ? Helpers.formatNumber(userInfo.remainTicket) : 0}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>

                    <Grid item xs={2} container justifyContent="flex-end" alignItems="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{maxHeight: 40}} // Limits the height of the button
                            onClick={this.fetchLogs}
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderLogs = () => {
        const {logs} = this.state;

        return <Paper>
            <Table sx={{border: 1, borderColor: 'grey.400'}}>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{borderRight: '1px solid grey'}}>ID</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>User ID</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>HQ Level</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>Login Count</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>Reward Type</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>Amount</TableCell>
                        <TableCell sx={{borderRight: '1px solid grey'}}>Created At</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        logs.map((log, index) => {
                            return <TableRow key={index}>
                                <TableCell>{log.id}</TableCell>
                                <TableCell>{log.userId}</TableCell>
                                <TableCell>{log.hqLevel}</TableCell>
                                <TableCell>{log.loginCount}</TableCell>
                                <TableCell>{this.getRewardType(log.rewardType)}</TableCell>
                                <TableCell>{Helpers.formatNumber(log.rewardAmount)}</TableCell>
                                <TableCell>{log.createdAt}</TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </Paper>
    }

    render() {
        const {classes} = this.props;
        return <Paper className="contentPadding">
            {this.renderCircle()}
            <br />
            {this.renderFilter()}
            <br />
            {this.renderLogs()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 0,
        backgroundColor: "black"
    },
});

export const LuckyWheel = withStyles(styles)(LuckyWheelWrapped);